/**
 * Lightweight tile-load performance tracker.
 * Records tile load durations and recommends offline download when loads are slow.
 */

let tileLoadTimes: number[] = [];
let recommendationShown = false;

/** Record a single tile load duration in milliseconds. */
export function recordTileLoad(durationMs: number) {
  tileLoadTimes.push(durationMs);
  if (tileLoadTimes.length > 50) tileLoadTimes = tileLoadTimes.slice(-50);
}

/** Average tile load time over recent samples (ms). Returns 0 when no data. */
export function getAvgTileLoad(): number {
  if (tileLoadTimes.length < 5) return 0;
  return tileLoadTimes.reduce((a, b) => a + b, 0) / tileLoadTimes.length;
}

/** Should we recommend offline download? Threshold: avg > 2s over 10+ samples. */
export function shouldRecommendDownload(): boolean {
  if (recommendationShown) return false;
  if (tileLoadTimes.length < 10) return false;
  return getAvgTileLoad() > 2000;
}

/** Mark recommendation as shown so it only triggers once per session. */
export function markRecommendationShown() {
  recommendationShown = true;
}

/** Reset state (e.g., when navigation ends). */
export function resetPerfMetrics() {
  tileLoadTimes = [];
  recommendationShown = false;
}
